import { ToolIcon } from '@clariness/clarikit-icons';
import { Box, Icon } from '@clariness/clarikit-react';
import { themes } from '@clariness/clarikit-tokens';
const { color, space } = themes.light;

export const ReportIssueIcon = () => {
  return (
    <Box
      display="flex"
      width={space['space-64']}
      height={space['space-64']}
      alignItems="center"
      justifyContent="center"
      backgroundColor={color['color-green-tertiary']}
      style={{ borderRadius: space['space-40'] }}
    >
      <Icon source={ToolIcon} size="medium" color="color-green-quaternary" />
    </Box>
  );
};
